import React, { useState, useEffect } from 'react';
import { Nav, NavItem, NavLink, Row, Col, Container } from 'reactstrap';
import Overview from './Overview'; // Import the new component
import MyStockPage from './MyStock';
import MyStockPlant from '../../../CandidateAndCompany/ProcessingPlant/processingplantStockAccept';
import CourierApproval from '../../../CandidateAndCompany/Courier/CourierAccept';
import ProcessingCost from '../../../CandidateAndCompany/ProcessingPlant/AddProcessingCost';
import OrderDashboard from './OrderDashboard';
import Vessels from './Vessels';
import CofRequests from './CofRequests';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Section from './Section';
import {
  faTachometerAlt,
  faServer,
  faShoppingBag,
  faGear,
  faPlusSquare,
} from '@fortawesome/free-solid-svg-icons';

const DashboardContent = () => {
  const [activeTab, setActiveTab] = useState('overview');

  useEffect(() => {
    const savedTab = localStorage.getItem('boatOwnerActiveTab');
    if (savedTab) {
      setActiveTab(savedTab);
    }
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    localStorage.setItem('boatOwnerActiveTab', tab);
  };

  const renderActivePage = () => {
    switch (activeTab) {
      case 'overview':
        return <Overview />;

      case 'Stocks':
        return <MyStockPage />;

      case 'ProcessingApproval':
        return <MyStockPlant />;

      case 'Vessels':
        return <Vessels />;

      case 'ProcessingCost':
        return <ProcessingCost />;

      case 'CourierApproval':
        return <CourierApproval />;

      case 'Settings':
        return <MyStockPage />;

      case 'Orders':
        return <OrderDashboard />;
      // Add more cases if you have other pages to load
      case 'Cof Requests':
        return <CofRequests />;
      default:
        return <Overview />;
    }
  };

  return (
    <Container fluid>
      <Section link="Boat Owner Dashboard" />
      <Row className="g-4">
        <Col
          md={12}
          lg={2}
          style={{
            background: 'white',
            borderRadius: '20px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
          }}
        >
          <ul
            id="menu-ul"
            style={{ paddingLeft: '10px' }}
          >
            <li
              style={{
                color: activeTab === 'overview' ? '#044B92' : '#000',
                backgroundColor: activeTab === 'overview' ? '#D8E6FA' : '#fff',
                borderRadius: '20px',
                transition: 'all 0.3s ease-in-out', // Add smooth transition
              }}
              href="#"
              onClick={() => handleTabChange('overview')}
            >
              <FontAwesomeIcon
                icon={faTachometerAlt}
                style={{ marginRight: '10px' }}
              />
              {'  '} Dashboard
            </li>

            <li
              style={{
                color: activeTab === 'Stocks' ? '#044B92' : '#000',
                backgroundColor: activeTab === 'Stocks' ? '#D8E6FA' : '#fff',
                borderRadius: '20px',
                transition: 'all 0.3s ease-in-out', // Add smooth transition
              }}
              href="#"
              onClick={() => handleTabChange('Stocks')}
            >
              <FontAwesomeIcon
                icon={faServer}
                style={{ marginRight: '10px' }}
              />
              {'  '} My Stocks
            </li>

            {/* <li
            style={{
              color: activeTab === 'ProcessingApproval' ? '#044B92' : '#000',
              backgroundColor:
                activeTab === 'ProcessingApproval' ? '#D8E6FA' : '#fff',
              borderRadius: '20px',
              transition: 'all 0.3s ease-in-out', // Add smooth transition
            }}
            href="#"
            onClick={() => setActiveTab('ProcessingApproval')}
          >
            <FontAwesomeIcon
              icon={faServer}
              style={{ marginRight: '10px' }}
            />
            {'  '} Processing Approval
          </li> */}
            {/* <li
            style={{
              color: activeTab === 'ProcessingCost' ? '#044B92' : '#000',
              backgroundColor:
                activeTab === 'ProcessingCost' ? '#D8E6FA' : '#fff',
              borderRadius: '20px',
              transition: 'all 0.3s ease-in-out', // Add smooth transition
            }}
            href="#"
            onClick={() => setActiveTab('ProcessingCost')}
          >
            <FontAwesomeIcon
              icon={faServer}
              style={{ marginRight: '10px' }}
            />
            {'  '} Processing Cost
          </li> */}

            {/* <li
            style={{
              color: activeTab === 'CourierApproval' ? '#044B92' : '#000',
              backgroundColor:
                activeTab === 'CourierApproval' ? '#D8E6FA' : '#fff',
              borderRadius: '20px',
              transition: 'all 0.3s ease-in-out', // Add smooth transition
            }}
            href="#"
            onClick={() => setActiveTab('CourierApproval')}
          >
            <FontAwesomeIcon
              icon={faServer}
              style={{ marginRight: '10px' }}
            />
            {'  '} Courier Approval
          </li> */}

            <li
              style={{
                color: activeTab === 'Orders' ? '#044B92' : '#000',
                backgroundColor: activeTab === 'Orders' ? '#D8E6FA' : '#fff',
                borderRadius: '20px',
                transition: 'all 0.3s ease-in-out', // Add smooth transition
              }}
              onClick={() => handleTabChange('Orders')}
            >
              <FontAwesomeIcon
                icon={faShoppingBag}
                style={{ marginRight: '10px' }}
              />
              {'  '} My Orders
            </li>

            <li
              style={{
                color: activeTab === 'Vessels' ? '#044B92' : '#000',
                backgroundColor: activeTab === 'Vessels' ? '#D8E6FA' : '#fff',
                borderRadius: '20px',
                transition: 'all 0.3s ease-in-out', // Add smooth transition
              }}
              onClick={() => handleTabChange('Vessels')}
            >
              <FontAwesomeIcon
                icon={faShoppingBag}
                style={{ marginRight: '10px' }}
              />
              {'  '} My Vessels
            </li>

            {/* <li
            style={{
              color: activeTab === 'Settings' ? '#044B92' : '#000',
              backgroundColor: activeTab === 'Settings' ? '#D8E6FA' : '#fff',
              borderRadius: '20px',
              transition: 'all 0.3s ease-in-out', // Add smooth transition
            }}
            href="#"
            onClick={() => setActiveTab('Settings')}
          >
            <FontAwesomeIcon
              icon={faGear}
              style={{ marginRight: '10px' }}
            />
            {'  '} Settings
          </li> */}

            <li
              style={{
                color: activeTab === 'Cof Requests' ? '#044B92' : '#000',
                backgroundColor:
                  activeTab === 'Cof Requests' ? '#D8E6FA' : '#fff',
                borderRadius: '20px',
                transition: 'all 0.3s ease-in-out', // Add smooth transition
              }}
              href="#"
              onClick={() => handleTabChange('Cof Requests')}
            >
              <FontAwesomeIcon
                icon={faPlusSquare}
                style={{ marginRight: '10px' }}
              />
              {'  '} Cof Requests
            </li>
          </ul>
        </Col>
        <Col
          md={12}
          lg={10}
        >
          {renderActivePage()}
        </Col>
      </Row>
    </Container>
  );
};

export default DashboardContent;
